import { IJsonQuery, EElevators } from '@cian/api-models/common/json_query';
import * as R from 'ramda';

import { EElevatorType } from './types';
import { setTerm, setRangeMin, resetTerms } from './helpers';

export function setElevatorType(jsonQuery: IJsonQuery) {
  return (elevatorType: EElevatorType | null): IJsonQuery => {
    let nextJsonQuery = R.clone(jsonQuery);

    nextJsonQuery = resetTerms(['lift_service', 'lifts'])(nextJsonQuery);

    if (elevatorType) {
      switch (elevatorType) {
        case EElevatorType.Any:
          nextJsonQuery = setTerm('lifts')(nextJsonQuery)(EElevators.One);
          break;
        case EElevatorType.Service:
          nextJsonQuery = setRangeMin('lift_service')(nextJsonQuery)(1);
          break;
      }
    }

    return nextJsonQuery;
  };
}
